import nonDisruptingError from '../error/non_disrupting_error';
import { logFunnelAnalyticsEvent } from '../logging/logger';
import { NO_FUNNEL_ANALYTICS_OBJECT } from '../../_constants/errors_messages';

const funnelyticsSend = (...args) => {
  if (location.href.indexOf('disableFunnelytics=1') === -1) {
    if (window.funnelytics) {
      logFunnelAnalyticsEvent(...args);
      window.funnelytics.events.trigger(...args);
    } else {
      nonDisruptingError(NO_FUNNEL_ANALYTICS_OBJECT);
    }
  }
};

const setBehaviourEvent = (args) =>
  funnelyticsSend(args.action, {
    event_category: args.category,
    event_label: args.label,
    value: args.value,
    non_interaction: args.nonInteraction,
    transport: args.beforeUnload ? 'beacon' : undefined,
  });

export { setBehaviourEvent };
